import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { getParentLayout, Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/index',
    name: 'index',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/Index/index.vue'),
        meta: {
          title: '首页管理',
          icon: 'carbon:home'
        }
      }
    ],
    meta: {
      title: '首页管理',
      roles: ['admin', 'service'],
      meta: 'carbon:home',
      noCache: true
    }
  },
  {
    path: '/user',
    name: 'WhiteIndex',
    component: Layout,
    redirect: 'user/list',
    children: [
      {
        path: 'list',
        name: 'WhiteIndex',
        component: () => import('@/views/WhiteList/WhiteIndex.vue'),
        meta: {
          title: '员工列表',
          icon: 'carbon:user-settings'
        }
      }
    ],
    meta: {
      title: '员工列表',
      roles: ['admin'],
      meta: 'carbon:user-settings',
      noCache: true
    }
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: Layout,
    redirect: '/announcement/list',
    children: [
      {
        path: 'list',
        name: 'Announcement',
        component: () => import('@/views/Announcement/Announcement.vue'),
        meta: {
          title: '公告管理',
          icon: 'carbon:align-box-top-left'
        }
      }
    ],
    meta: {
      title: '公告管理',
      roles: ['admin', 'service'],
      meta: 'carbon:align-box-top-left',
      noCache: true
    }
  },
  {
    path: '/community',
    name: 'Community',
    component: Layout,
    redirect: '/community/list',
    children: [
      {
        path: 'list',
        name: 'Community',
        component: () => import('@/views/Community/Community.vue'),
        meta: {
          title: '社区管理',
          icon: 'carbon:airline-rapid-board'
        }
      }
    ],
    meta: {
      title: '社区管理',
      roles: ['admin'],
      meta: 'carbon:airline-rapid-board',
      noCache: true
    }
  },
  // {
  //   path: '/level',
  //   component: Layout,
  //   redirect: '/level/menu1/menu1-1/menu1-1-1',
  //   name: 'Level',
  //   meta: {
  //     title: t('router.level'),
  //     icon: 'carbon:skill-level-advanced'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       name: 'Menu1',
  //       component: getParentLayout(),
  //       redirect: '/level/menu1/menu1-1/menu1-1-1',
  //       meta: {
  //         title: t('router.menu1')
  //       },
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           name: 'Menu11',
  //           component: getParentLayout(),
  //           redirect: '/level/menu1/menu1-1/menu1-1-1',
  //           meta: {
  //             title: t('router.menu11'),
  //             alwaysShow: true
  //           },
  //           children: [
  //             {
  //               path: 'menu1-1-1',
  //               name: 'Menu111',
  //               component: () => import('@/views/Level/Menu111.vue'),
  //               meta: {
  //                 title: t('router.menu111')
  //               }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-2',
  //           name: 'Menu12',
  //           component: () => import('@/views/Level/Menu12.vue'),
  //           meta: {
  //             title: t('router.menu12')
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       name: 'Menu2',
  //       component: () => import('@/views/Level/Menu2.vue'),
  //       meta: {
  //         title: t('router.menu2')
  //       }
  //     }
  //   ]
  // },
  {
    path: '/love/channel',
    component: Layout,
    name: 'LoveChannel',
    redirect: '/love/channel/list',
    children: [
      {
        path: 'list',
        name: 'LoveChannel',
        component: () => import('@/views/LoveChannel/LoveChannel.vue'),
        meta: {
          title: '爱心通道',
          icon: 'carbon:location-heart'
        }
      }
    ],
    meta: {
      title: '爱心通道列表',
      roles: ['admin'],
      icon: 'carbon:location-heart',
      noCache: true
    }
  },
  {
    path: '/activity/video',
    component: Layout,
    name: 'ActivityVideo',
    redirect: '/activity/video/list',
    children: [
      {
        path: 'list',
        name: 'ActivityVideo',
        component: () => import('@/views/Activity/ActivityVideo.vue'),
        meta: {
          title: '活动视频',
          icon: 'carbon:video-player'
        }
      }
    ],
    meta: {
      title: '活动视频',
      roles: ['admin', 'service'],
      icon: 'carbon:video-player',
      noCache: true
    }
  },
  {
    path: '/activity/info',
    component: Layout,
    name: 'ActivityInfo',
    redirect: '/activity/info/list',
    children: [
      {
        path: 'list',
        name: 'ActivityInfo',
        component: () => import('@/views/Activity/ActivityInfo.vue'),
        meta: {
          title: '节日活动',
          icon: 'carbon:gift'
        }
      }
    ],
    meta: {
      title: '节日活动',
      roles: ['admin', 'service'],
      icon: 'carbon:gift',
      noCache: true
    }
  },
  // {
  //   path: '/sport/reimbursement',
  //   component: Layout,
  //   name: 'reimbursement',
  //   redirect: '/sport/reimbursement/list',
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'reimbursement',
  //       component: () => import('@/views/sport/reimbursement.vue'),
  //       meta: {
  //         title: '体育报销',
  //         icon: 'carbon:running'
  //       }
  //     }
  //   ],
  //   meta: {
  //     title: '体育报销',
  //     icon: 'carbon:running',
  //     noCache: true
  //   }
  // },
  {
    path: '/message/box',
    component: Layout,
    name: 'MessageBox',
    redirect: '/message/box/list',
    children: [
      {
        path: 'list',
        name: 'MessageBox',
        component: () => import('@/views/MessageBox/MessageBox.vue'),
        meta: {
          title: '留言箱',
          icon: 'carbon:mail-all'
        }
      }
    ],
    meta: {
      title: '留言箱',
      roles: ['admin'],
      icon: 'carbon:mail-all',
      noCache: true
    }
  },
  // {
  //   path: '/provisional/activity',
  //   component: Layout,
  //   name: 'sport',
  //   redirect: '/provisional/activity/sport',
  //   children: [
  //     {
  //       path: 'sport',
  //       name: 'AiSport',
  //       component: () => import('@/views/AiSport/AiSport.vue'),
  //       meta: {
  //         title: 'AI运动',
  //         icon: 'carbon:gui-management'
  //       }
  //     }
  //   ],
  //   meta: {
  //     title: '小程序管理',
  //     icon: 'carbon:gui-management',
  //     noCache: true
  //   }
  // },
  {
    path: '/colorful-activity',
    component: Layout,
    name: 'ColorfulActivityCenter',
    // biz_admin 只有产品中心/订单中心, 没有"缤纷活动区管理", 按实际已注册的路由决定落地页
    redirect: () =>
      router.hasRoute('ColorfulActivity')
        ? '/colorful-activity/manage'
        : '/colorful-activity/order-center',
    meta: {
      title: '缤纷活动区',
      roles: ['admin', 'service', 'biz_admin'],
      icon: 'carbon:gui-management',
      alwaysShow: true
    },
    children: [
      {
        path: 'manage',
        name: 'ColorfulActivity',
        component: () => import('@/views/AppManage/ColorfulActivity.vue'),
        meta: {
          title: '缤纷活动区管理',
          roles: ['admin', 'service']
        }
      },
      {
        path: 'product-center',
        name: 'ProductCenter',
        component: getParentLayout(),
        redirect: '/colorful-activity/product-center/venue',
        meta: {
          title: '产品中心',
          alwaysShow: true,
          roles: ['super']
        },
        children: [
          {
            path: 'venue',
            name: 'VenueProductCenter',
            component: () => import('@/views/Venue/VenueProduct.vue'),
            meta: { title: '运动场馆产品' }
          },
          {
            path: 'family-day',
            name: 'FamilyDayProductCenter',
            component: () => import('@/views/FamilyDay/FamilyDayProduct.vue'),
            meta: { title: '家庭日产品' }
          },
          {
            path: 'night-class',
            name: 'NightClassProductCenter',
            component: () => import('@/views/NightClass/NightClassProduct.vue'),
            meta: { title: '兴趣班产品' }
          },
          {
            path: 'venue/info',
            name: 'VenueProductCenterInfo',
            component: () => import('@/views/Biz/components/ProductInfo.vue'),
            meta: {
              title: '运动场馆产品详情',
              hidden: true,
              canTo: true,
              activeMenu: '/colorful-activity/product-center/venue',
              productTyp: 2
            }
          },
          {
            path: 'night-class/info',
            name: 'NightClassProductCenterInfo',
            component: () => import('@/views/Biz/components/ProductInfo.vue'),
            meta: {
              title: '兴趣班产品详情',
              hidden: true,
              canTo: true,
              activeMenu: '/colorful-activity/product-center/night-class',
              productTyp: 4
            }
          },
          {
            path: 'family-day/info',
            name: 'FamilyDayProductCenterInfo',
            component: () => import('@/views/FamilyDay/components/FamilyDayProductInfo.vue'),
            meta: {
              title: '家庭日产品详情',
              hidden: true,
              canTo: true,
              activeMenu: '/colorful-activity/product-center/family-day'
            }
          }
        ]
      },
      {
        path: 'order-center',
        name: 'OrderCenter',
        component: getParentLayout(),
        redirect: '/colorful-activity/order-center/venue',
        meta: { title: '订单中心', alwaysShow: true, roles: ['admin', 'biz_admin'] },
        children: [
          {
            path: 'venue',
            name: 'VenueOrderCenter',
            component: () => import('@/views/Venue/VenueOrderList.vue'),
            meta: { title: '运动场馆订单' }
          },
          {
            path: 'family-day',
            name: 'FamilyDayOrderCenter',
            component: () => import('@/views/FamilyDay/FamilyDayOrderList.vue'),
            meta: { title: '家庭日订单' }
          },
          {
            path: 'night-class',
            name: 'NightClassOrderCenter',
            component: () => import('@/views/NightClass/NightClassOrderList.vue'),
            meta: { title: '兴趣班订单' }
          },
          {
            path: 'check-in',
            name: 'CheckInCenter',
            component: () => import('@/views/CheckIn/CheckInList.vue'),
            meta: { title: '签到列表' }
          },
          {
            path: 'venue/info',
            name: 'VenueOrderCenterInfo',
            component: () => import('@/views/Venue/components/VenueOrderInfo.vue'),
            meta: {
              title: '运动场馆订单详情',
              hidden: true,
              canTo: true,
              activeMenu: '/colorful-activity/order-center/venue'
            }
          },
          {
            path: 'night-class/info',
            name: 'NightClassOrderCenterInfo',
            component: () => import('@/views/NightClass/components/NightClassOrderInfo.vue'),
            meta: {
              title: '兴趣班订单详情',
              hidden: true,
              canTo: true,
              activeMenu: '/colorful-activity/order-center/night-class'
            }
          },
          {
            path: 'family-day/info',
            name: 'FamilyDayOrderCenterInfo',
            component: () => import('@/views/FamilyDay/components/FamilyDayOrderInfo.vue'),
            meta: {
              title: '家庭日订单详情',
              hidden: true,
              canTo: true,
              activeMenu: '/colorful-activity/order-center/family-day'
            }
          }
        ]
      }
      // {
      //   path: 'editable-category',
      //   name: 'EditableCategoryConfig',
      //   component: () => import('@/views/SystemConfig/EditableCategory.vue'),
      //   meta: { title: '可操作产品设置' }
      // }
    ]
  },
  {
    path: '/award',
    component: Layout,
    name: 'Award',
    redirect: '/award/list',
    children: [
      {
        path: 'list',
        name: 'Award',
        component: () => import('@/views/Award/ActivityAward.vue'),
        meta: {
          title: '活动兑奖'
        }
      },
      {
        path: 'welfare/list',
        name: 'WeflareAward',
        component: () => import('@/views/Award/WeflareAward.vue'),
        meta: {
          title: '福利兑奖'
        }
      }
    ],
    meta: {
      title: '待办事项',
      roles: ['admin', 'service'],
      icon: 'carbon:gui-management',
      noCache: true
    }
  },
  {
    path: '/welfare',
    component: Layout,
    name: 'Welfare',
    redirect: '/welfare/index',
    children: [
      {
        path: 'index',
        name: 'Welfare',
        component: () => import('@/views/Welfare/Welfare_v2.vue'),
        meta: {
          title: '福利首页',
          icon: 'solar:sun-outline'
        }
      },
      {
        path: 'lehuigou',
        name: 'Lehuigou',
        component: () => import('@/views/Welfare/Lehuigou.vue'),
        meta: {
          title: '乐惠购',
          icon: 'solar:sun-outline'
        }
      }
    ],
    meta: {
      title: '福利管理',
      roles: ['admin', 'service'],
      icon: 'solar:sun-outline',
      noCache: true
    }
  },
  {
    path: '/venue',
    component: Layout,
    name: 'Venue',
    redirect: '/venue/list',
    children: [
      {
        path: 'list',
        name: 'VenueProductList',
        component: () => import('@/views/Venue/VenueProduct.vue'),
        meta: {
          title: '产品列表'
        }
      },
      {
        path: 'order/list',
        name: 'VenueOrderList',
        component: () => import('@/views/Venue/VenueOrderList.vue'),
        meta: {
          title: '订单列表'
        }
      },
      {
        path: 'product/info',
        name: 'VenueProductInfo',
        // 与兴趣班共用同一个产品详情/编辑组件(接口/字段完全一致, 仅 productTyp 不同), 见该组件顶部注释
        component: () => import('@/views/Biz/components/ProductInfo.vue'),
        meta: {
          title: '产品详情',
          activeMenu: '/venue/list',
          hidden: true,
          // hidden 路由默认会被 frontEnd 角色过滤丢弃, canTo + followRoute 让它跟随父级路径一起放行
          canTo: true,
          followRoute: '/venue/list',
          productTyp: 2
        }
      },
      {
        path: 'order/info',
        name: 'VenueOrderInfo',
        component: () => import('@/views/Venue/components/VenueOrderInfo.vue'),
        meta: {
          title: '订单详情',
          activeMenu: '/venue/order/list',
          hidden: true,
          canTo: true,
          followRoute: '/venue/order/list'
        }
      }
    ],
    meta: {
      title: '运动场馆预约',
      hidden: true,
      roles: ['admin', 'service'],
      icon: 'carbon:location-current',
      noCache: true
    }
  },
  {
    path: '/night-class',
    component: Layout,
    name: 'NightClass',
    redirect: '/night-class/list',
    children: [
      {
        path: 'list',
        name: 'NightClassProductList',
        component: () => import('@/views/NightClass/NightClassProduct.vue'),
        meta: {
          title: '产品列表'
        }
      },
      {
        path: 'order/list',
        name: 'NightClassOrderList',
        component: () => import('@/views/NightClass/NightClassOrderList.vue'),
        meta: {
          title: '订单列表'
        }
      },
      {
        path: 'product/info',
        name: 'NightClassProductInfo',
        // 与运动场馆预约共用同一个产品详情/编辑组件(接口/字段完全一致, 仅 productTyp 不同), 见该组件顶部注释
        component: () => import('@/views/Biz/components/ProductInfo.vue'),
        meta: {
          title: '产品详情',
          activeMenu: '/night-class/list',
          hidden: true,
          canTo: true,
          followRoute: '/night-class/list',
          productTyp: 4
        }
      },
      {
        path: 'order/info',
        name: 'NightClassOrderInfo',
        component: () => import('@/views/NightClass/components/NightClassOrderInfo.vue'),
        meta: {
          title: '订单详情',
          activeMenu: '/night-class/order/list',
          hidden: true,
          canTo: true,
          followRoute: '/night-class/order/list'
        }
      }
    ],
    meta: {
      title: '兴趣班',
      hidden: true,
      roles: ['admin', 'service'],
      icon: 'mdi:bike-fast',
      noCache: true
    }
  },
  {
    path: '/family-day',
    component: Layout,
    name: 'FamilyDay',
    redirect: '/family-day/list',
    children: [
      {
        path: 'list',
        name: 'FamilyDayProductList',
        component: () => import('@/views/FamilyDay/FamilyDayProduct.vue'),
        meta: {
          title: '产品列表'
        }
      },
      {
        path: 'order/list',
        name: 'FamilyDayOrderList',
        component: () => import('@/views/FamilyDay/FamilyDayOrderList.vue'),
        meta: {
          title: '订单列表'
        }
      },
      {
        path: 'product/info',
        name: 'FamilyDayProductInfo',
        component: () => import('@/views/FamilyDay/components/FamilyDayProductInfo.vue'),
        meta: {
          title: '产品详情',
          activeMenu: '/family-day/list',
          hidden: true,
          canTo: true,
          followRoute: '/family-day/list'
        }
      },
      {
        path: 'order/info',
        name: 'FamilyDayOrderInfo',
        component: () => import('@/views/FamilyDay/components/FamilyDayOrderInfo.vue'),
        meta: {
          title: '订单详情',
          activeMenu: '/family-day/order/list',
          hidden: true,
          canTo: true,
          followRoute: '/family-day/order/list'
        }
      }
    ],
    meta: {
      title: '家庭日',
      hidden: true,
      roles: ['admin', 'service'],
      icon: 'carbon:campsite',
      noCache: true
    }
  },
  {
    path: '/mar-ticket',
    component: Layout,
    name: 'MarTicket',
    redirect: '/mar-ticket/list',
    children: [
      {
        path: 'list',
        name: 'MarTicketProductList',
        component: () => import('@/views/MarTicket/MarTicketProduct.vue'),
        meta: {
          title: '产品列表'
        }
      },
      {
        path: 'order/list',
        name: 'MarTicketOrderList',
        component: () => import('@/views/MarTicket/MarTicketOrderList.vue'),
        meta: {
          title: '订单列表'
        }
      },
      {
        path: 'product/info',
        name: 'MarTicketProductInfo',
        component: () => import('@/views/MarTicket/components/MarTicketProductInfo.vue'),
        meta: {
          title: '产品详情',
          activeMenu: '/mar-ticket/list',
          hidden: true,
          canTo: true,
          followRoute: '/mar-ticket/list'
        }
      },
      {
        path: 'order/info',
        name: 'MarTicketOrderInfo',
        component: () => import('@/views/MarTicket/components/MarTicketOrderInfo.vue'),
        meta: {
          title: '订单详情',
          activeMenu: '/mar-ticket/order/list',
          hidden: true,
          canTo: true,
          followRoute: '/mar-ticket/order/list'
        }
      }
    ],
    meta: {
      title: '抢票',
      hidden: true,
      roles: ['admin', 'service'],
      icon: 'carbon:ticket',
      noCache: true
    }
  },
  {
    path: '/qs-mock',
    component: Layout,
    name: 'mockIndex',
    redirect: '/welfare/index',
    children: [
      {
        path: 'index',
        name: 'MockIndex',
        component: () => import('@/views/mock/MockIndex.vue'),
        meta: {
          title: '模拟器',
          icon: 'carbon:game-wireless'
        }
      }
    ],
    meta: {
      title: '模拟器',
      roles: ['admin', 'service'],
      icon: 'carbon:game-wireless',
      noCache: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
